import {
    Component,
    HostListener,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { ToggleService } from './toggle.service';
import { DatePipe } from '@angular/common';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
import { LanguageService } from 'src/app/core/services/languages/language.service';
import { TranslateService } from '@ngx-translate/core';
import { listLang } from 'src/app/core/constants/languages';
import { NavigationService } from 'src/app/core/services/navigation/navigation.service';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { ApplicationMasterService } from 'src/app/core/services/applicationMaster/application-master.service';
import { LoaderService } from 'src/app/core/services/loader/loader.service';
import { MatMenuTrigger } from '@angular/material/menu';
import { urlRoutes } from 'src/app/core/constants/url-route.constant';
import { Router } from '@angular/router';
import { permissionEntity } from 'src/app/core/constants/permission';
import { PaginationType } from 'src/app/core/interfaces/pagination/pagination-type';
import { PageEvent } from '@angular/material/paginator';
import { filePathWithBaseURL } from 'src/app/core/helpers/helperfunc';
import { AuthenticationService } from 'src/app/core/services/auth/authentication.service';
import { AdminNoticePopupComponent } from './admin-notice-popup/admin-notice-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { NoticeBoardService } from 'src/app/core/services/notice-board/notice-board.service';
// import { io } from 'socket.io-client';
// import { SocketService } from 'src/app/core/services/socket/socket.service';
import { UserListComponent } from 'src/app/views/profile/user-list/user-list.component';
import { LocalStorageService } from 'src/app/core/services/localStorage/localStorage.service';
import { CookieService } from 'src/app/core/services/cookie/cookie.service';

export interface MultiLanguage {
    text?: string;
    flag?: string;
    lang?: string;
}

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
    currentIndex: number = 0;
    canOpenModal: boolean = true;
    isModalOpen: boolean = false;
    dropdownsVisible: boolean = false;

    isSticky: boolean = false;
    supportedLanguages: MultiLanguage[] = listLang;
    selectedLanguage: MultiLanguage = listLang[0];
    cookieValue: any;
    isToggled = false;
    currentDate: Date = new Date();
    formattedDate: any = this.datePipe.transform(
        this.currentDate,
        'dd MMMM yyyy'
    );
    role_name: any;
    value: boolean = true;
    exitToMainProfile: boolean = false;
    private dataSubject = new BehaviorSubject<any>(null);

    @HostListener('window:scroll', ['$event'])
    checkScroll() {
        const scrollPosition =
            window.pageYOffset ||
            document.documentElement.scrollTop ||
            document.body.scrollTop ||
            0;
        if (scrollPosition >= 50) {
            this.isSticky = true;
        } else {
            this.isSticky = false;
        }
    }
    user_details: any;
    search: string;
    search_applicant_list: any;
    private _unsubscribeAll: Subject<any> = new Subject();
    @ViewChild('applicant_menu_trigger') applicant_menu_trigger: MatMenuTrigger;
    permissions_entity = permissionEntity;
    pagination_config: PaginationType = {
        size: 10,
        total: 0,
        skip: 0,
        limit: 10,
    };
    file_path_with_base_url = filePathWithBaseURL;

    noticeData: any = [];
    noticeList: any = [];
    isActiveSwitchUser: boolean = false;
    activeSwitchUserDetails: any = null;
    showDeligateOption: boolean = false

    constructor(
        private toggleService: ToggleService,
        private datePipe: DatePipe,
        public dialog: MatDialog,
        public themeService: CustomizerSettingsService,
        public translate: TranslateService,
        public languageService: LanguageService,
        // public _cookiesService: CookieService,
        private navigationService: NavigationService,
        private _appMasterService: ApplicationMasterService,
        private _loaderService: LoaderService,
        private _router: Router,
        private _authService: AuthenticationService,
        private _noticeBoardService: NoticeBoardService,
        // private _socketService: SocketService,
        private __localStorageService: LocalStorageService,
        private cookieService: CookieService
    ) {
        this.toggleService.isToggled$.subscribe((isToggled) => {
            this.isToggled = isToggled;
        });
    }

    ngOnInit(): void {
        this.showDeligateOption = !!this.__localStorageService.getKey('accountAccess')
        const isModalOpen__ = localStorage.getItem('isModalOpen');
        const modalData__ = localStorage.getItem('modalData');
        this.isActiveSwitchUser = !!this.__localStorageService.getSwitchedUserDetails();
        if (this.isActiveSwitchUser) {
            this.activeSwitchUserDetails = this.__localStorageService.getSwitchedUserDetails()?.user_details;
        }

        if (isModalOpen__ === 'true' && modalData__) {
            // Reopen the modal with the saved data
            this.openModal(JSON.parse(modalData__));
        }
        // this.user_details = JSON.parse(localStorage.getItem('user_details'));
        this.user_details = this._authService.getLoginUserDetails();
        this.role_name = this.user_details?.roles[0]?.name;

        this._authService
            .triggerProfilePicUpdate()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((res: boolean) => {
                if (res) {
                    this.user_details = this._authService.getLoginUserDetails();
                }
            });

        this.dataSubject.subscribe((data) => {
            if (data) {
                if (JSON.parse(localStorage.getItem('noticeList'))) {
                    let prvNotice = JSON.parse(
                        localStorage.getItem('noticeList')
                    );
                    this.noticeList = prvNotice;
                }
                this.noticeList.push(data);
                localStorage.setItem(
                    'noticeList',
                    JSON.stringify(this.noticeList)
                );
                this.callMyNotificaiton(data?.userType);
            }
        });

        let userId =
            this.user_details?.id || '';

        // this._socketService
        //     .listenToChannel('portal-notification')
        //     .subscribe((data: any) => {
        //         if (
        //             data &&
        //             data?.sourceArray
        //                 .map((item) => item?.userId)
        //                 .includes(userId) &&
        //             data?.userType === 'admin'
        //         ) {
        //             this.dataSubject.next(data);
        //         }
        //     });

        //socket code
        // const socket = io('wss://api-dev.crizac.com', {
        //     transports: ['websocket'],
        // });
        // socket.on('connect', () => {
        //     console.log('Connected to WebSocket server');
        //     //this.callMyNotificaiton();

        //     // Listen for the 'portal-notification' event
        //     socket.on('portal-notification', (data) => {
        //         console.log(data);

        //         if (data.userType == 'admin') {
        //             this.dataSubject.next(data);
        //             // this.callMyNotificaiton(data);
        //             // console.log('Received portal-notification:', data);
        //             // if (this.dataSubject.getValue() !== data) {
        //             //     // Update the BehaviorSubject with the new data
        //             //     this.dataSubject.next(data);
        //             //     console.log(this.dataSubject);

        //             // }
        //         }
        //     });
        // });

        // socket.on('disconnect', () => {
        //     console.log('Disconnected from WebSocket server');
        // });
        //socket code
    }

    callMyNotificaiton(type) {
        let notificationType = type ? type : 'webinar,notice';
        this.showAdminNotice(notificationType);
    }
    public changeLanguage(lang: MultiLanguage): void {
        this.languageService.setLanguage(lang.lang);
        this.selectedLanguage = lang;
    }

    toggleTheme() {
        this.themeService.toggleTheme();
    }

    toggle() {
        this.toggleService.toggle();
    }

    toggleSidebarTheme() {
        this.themeService.toggleSidebarTheme();
    }

    toggleHideSidebarTheme() {
        this.themeService.toggleHideSidebarTheme();
    }

    toggleCardBorderTheme() {
        this.themeService.toggleCardBorderTheme();
    }

    toggleHeaderTheme() {
        this.themeService.toggleHeaderTheme();
    }

    toggleCardBorderRadiusTheme() {
        this.themeService.toggleCardBorderRadiusTheme();
    }

    toggleRTLEnabledTheme() {
        this.themeService.toggleRTLEnabledTheme();
    }

    onLogout() {
        let payload = {
            "token": this.cookieService.getCookie('ref_token'),
        }
        this._authService.logOut(payload)
        .subscribe((res) => {
            this.cookieService.deleteCookie('ref_token');
            this.cookieService.deleteCookie('sw_ref_token');
            localStorage.removeItem('access_token');
            sessionStorage.clear();
            localStorage.clear();
            window.location.reload();
            this.navigationService.routeToPath('/authentication/login');
        },
        (err)=>{
            this.cookieService.deleteCookie('ref_token');
            this.cookieService.deleteCookie('sw_ref_token');
            localStorage.removeItem('access_token');
            sessionStorage.clear();
            localStorage.clear();
            window.location.reload();
            this.navigationService.routeToPath('/authentication/login');
        }
        );
       
    }
    getConvertedArray(data: any[]): any[] {
        return data.map(item => ({
            ...item, // Spread the existing properties of the item
            dynamicUrl: this.buildDynamicUrl(item), // Add the new property
        }));
    }

    private buildDynamicUrl(element: any): string {
        return `${urlRoutes.mainLayout}/${urlRoutes.application_master}/${urlRoutes.app_master_info}/${element.id}`;
        return `${urlRoutes.mainLayout}/${urlRoutes.application_master}/${urlRoutes.app_master_info}/${element.id}/${element.masterId}/${element?.coursesEnrolementRef?.universityId}`;
    }

    searchApplicant() {
        if (this.search) {
            this._loaderService.showLoader();
            this._appMasterService
                .globalSearch(this.pagination_config, this.search.trim())
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(
                    (result) => {
                        if (result) {
                            this._loaderService.hideLoader();
                            this.search_applicant_list = this.getConvertedArray(result?.data?.data);
                            this.pagination_config.total = result?.data?.total;
                            this.applicant_menu_trigger.openMenu();
                        }
                    },
                    (err) => {
                        this._loaderService.hideLoader();
                    }
                );
        }
    }

    seeDetails(applicant: any) {
        let url = `${urlRoutes.mainLayout}/${urlRoutes.application_master}/${urlRoutes.app_master_info}/${applicant.id}/${applicant.masterId}/${applicant?.coursesEnrolementRef?.universityId}`;
        if (this._router.url.includes('app_master_info')) {
            this._router.navigate([url]).then(() => {
                window.location.reload();
            });
        } else {
            this._router.navigate([url]);
        }
    }

    showAdminNotice(data) {
        if (this.canOpenModal && !this.isModalOpen) {
            const savedNoticeList = localStorage.getItem('noticeList');
            if (savedNoticeList && savedNoticeList.length > 0) {
                const data = JSON.parse(savedNoticeList);
                this.noticeData = savedNoticeList;
                if (this.currentIndex < data.length) {
                    this.canOpenModal = false; // Prevent opening another modal
                    if (
                        data[this.currentIndex].referenceModule == 'adminNotice'
                    ) {
                        this.openModal(data[this.currentIndex]);
                    }
                }
                if (this.currentIndex == data.length) {
                    localStorage.removeItem('noticeList');
                }
            }
            // this._noticeBoardService
            //     .getNoticePopup(this.user_details.id)
            //     .subscribe((res) => {
            //         if (
            //             res.statusCode === 200 &&
            //             res.success &&
            //             res?.data &&
            //             res?.data?.data &&
            //             res?.data?.data.length > 0
            //         ) {
            //             this.currentIndex = 0;

            //             const data = res.data.data;
            //             this.noticeData = res.data.data;

            //             if (this.currentIndex < data.length) {
            //                 this.canOpenModal = false; // Prevent opening another modal
            //                 console.log(this.currentIndex);
            //                 this.openModal(data[this.currentIndex]);
            //             }
            //         }
            //     });
        }
    }

    public openModal(item: any) {
        localStorage.setItem('isModalOpen', 'true');
        localStorage.setItem('modalData', JSON.stringify(item));

        const dialogRef = this.dialog.open(AdminNoticePopupComponent, {
            width: '60%',
            enterAnimationDuration: '50ms',
            exitAnimationDuration: '100ms',
            minHeight: '400px',
            disableClose: true,
            maxHeight: '700px',
            data: { data: item },
        });

        dialogRef.afterClosed().subscribe((result) => {
            this.canOpenModal = true;
            this.isModalOpen = false;
            this.currentIndex++;
            localStorage.removeItem('isModalOpen');
            localStorage.removeItem('modalData');
            this.showAdminNotice(item);
        });
    }

    public pagination(event: PageEvent) {
        //add function to component ts file
        this.pagination_config.skip = event.pageIndex * event.pageSize;
        this.pagination_config.limit = event.pageSize;
        this.searchApplicant();
    }

    userData() {
        const dialogRef = this.dialog.open(UserListComponent, {
            width: '1260px',
            maxWidth: '90vw',
            enterAnimationDuration: '300ms',
            exitAnimationDuration: '100ms',
            hasBackdrop: true, // Keep the backdrop to maintain modal behavior
            panelClass: 'custom-dialog', // Apply custom styles
            disableClose: true, // Prevent closing on clicking outside the dialog
            data: {}, // Pass data if required
        });
        // dialogRef.afterClosed().subscribe((result) => {
        //   if (result) {
        //     //this.paginator.pageIndex = 0;
        //     this.paginationConfigService.setPageIndex(0);
        //     this.pagination_config = { skip: 0, limit: this.pagination_config.limit };
        //     if (result === FilterType.reset) {
        //       if (getAppliedFilters(FilterConstant.agents_applied_filter).applied_filter_count) {
        //         this._localStorageService.removeKey(FilterConstant.agents_applied_filter);
        //         this.initialSubscribers();
        //       }
        //     } else {
        //       this.initialSubscribers();
        //     }
        //   }
        // });
    }

    backToMainProfile(){
        this.exitToMainProfile = true;
    }
    setValue(){
        this.__localStorageService.setKey('isPermission','false')
    }
    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
